import React from "react";

// Effets visuels d'attaque "Summoners War" affichés sur la cible, selon l'élément/type.
const FX_CONFIG = {
  fire: { color: "#fb923c", emoji: "🔥", ring: "rgba(251,146,60,0.65)" },
  ice: { color: "#67e8f9", emoji: "❄️", ring: "rgba(103,232,249,0.65)" },
  earth: { color: "#b45309", emoji: "🪨", ring: "rgba(180,83,9,0.6)" },
  wind: { color: "#bae6fd", emoji: "🌀", ring: "rgba(186,230,253,0.6)" },
  light: { color: "#fde68a", emoji: "✨", ring: "rgba(253,230,138,0.7)" },
  shadow: { color: "#c084fc", emoji: "🌑", ring: "rgba(192,132,252,0.6)" },
  slash: { color: "#ffffff", emoji: "💢", ring: "rgba(255,255,255,0.6)" },
  buff: { color: "#34d399", emoji: "✨", ring: "rgba(52,211,153,0.65)" },
};

export const AttackFX = ({ type = "slash", testId = "attack-fx" }) => {
  const cfg = FX_CONFIG[type] || FX_CONFIG.slash;
  const particles = type === "buff" ? 6 : 8;
  return (
    <div data-testid={testId} className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center overflow-visible">
      {/* Flash radial */}
      <div className="absolute w-28 h-28 rounded-full animate-fx-flash" style={{ background: `radial-gradient(circle, ${cfg.ring} 0%, transparent 70%)` }} />
      {/* Anneau qui s'étend */}
      <div className="absolute w-16 h-16 rounded-full border-4 animate-fx-ring" style={{ borderColor: cfg.color }} />
      {/* Lacération (attaque physique) */}
      {(type === "slash") && (
        <div className="absolute w-32 h-2 rounded-full animate-fx-slash" style={{ background: `linear-gradient(90deg, transparent, ${cfg.color}, transparent)` }} />
      )}
      {/* Éclat de particules */}
      {Array.from({ length: particles }).map((_, i) => {
        const ang = (i / particles) * Math.PI * 2;
        const dist = 52;
        return (
          <span
            key={i}
            className="absolute text-2xl animate-fx-particle"
            style={{ "--tx": `${Math.cos(ang) * dist}px`, "--ty": `${Math.sin(ang) * dist}px`, animationDelay: `${i * 12}ms` }}
          >
            {cfg.emoji}
          </span>
        );
      })}
    </div>
  );
};
